window.infoLineaTiempoMuertoInyeccion = null;

if (window.location.pathname === "/inyeccion/periodo" || window.location.pathname === "/zona-trabajo") {
    
    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
    };

    const modalEditarTiempoMuerto = document.querySelector("#formEditarTiempoMuerto");
    let idLineaProduccion = modalEditarTiempoMuerto.querySelector("#idLineaTiempoMuerto").value;
    
    window.infoLineaTiempoMuertoInyeccion = (idLineaProduccion) => {
        
        const url = `/api/inyeccion/lineaTiempoMuerto?idLine=${idLineaProduccion}`;

        const divModalEditarTiempoMuerto = document.querySelector("#contEditarTiempoMuertoInyeccion");
        
        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }
                return response.json();
            })
            .then((result) => {

                const data = Array.isArray(result.result) ? result.result[0] : null;

                if (!data) {
                    throw new Error("No se encontró la línea de tiempo muerto de inyección solicitada.");
                }
                
                const int = n => (Number(n) || 0);
                
                divModalEditarTiempoMuerto.querySelectorAll('.inputRojo').forEach(input => input.classList.remove('inputRojo'));
                
                const horaInicio = divModalEditarTiempoMuerto.querySelector("#horaInicio");
                const horaFin = divModalEditarTiempoMuerto.querySelector("#horaFin");
                const idCausaTiempoMuerto = divModalEditarTiempoMuerto.querySelector("#idCausaTiempoMuerto");
                divModalEditarTiempoMuerto.classList.toggle('canvaBloqueado', Number(data.estadoReporteInyeccion) != 1);
                const contBtnModal = divModalEditarTiempoMuerto.querySelector('.contBtnModal');
                if (contBtnModal) {
                    contBtnModal.classList.toggle('oculto', Number(data.estadoReporteInyeccion) != 1);
                }

                if (horaInicio && horaFin && idCausaTiempoMuerto) {
                    horaInicio.value = data.horaInicio;
                    horaFin.value = data.horaFin;
                    idCausaTiempoMuerto.value = int(data.idCausaTiempoMuerto);
                }
            })
            .catch((error) => {
                console.error("Error en la solicitud:", error);
                alert("Ocurrió un error al cargar la información del tiempo muerto. Por favor, intenta nuevamente.");
                return;
            });
    };

    document.addEventListener('click', function (e) {
        const trAbrir = e.target.closest('.trSelectTiempoMuerto[data-modal="modalEditarTiempoMuerto"]');
        if (trAbrir) {
            const idLineaProduccion = trAbrir.getAttribute('data-id');
            const modalEditarLineaPnc = document.querySelector('#formEditarTiempoMuerto');
            const modalReporteInyeccion = document.querySelector('#formProduccionInyeccion');
            const inputReporteInyeccion = modalReporteInyeccion ? modalReporteInyeccion.querySelector('#idReporteInyeccion') : null;
            let idPncInyeccion = inputReporteInyeccion ? inputReporteInyeccion.value : '';

            if (!idLineaProduccion || !modalEditarLineaPnc || !modalReporteInyeccion || isNaN(idLineaProduccion) || isNaN(idPncInyeccion)) {
                alert("No se encontró el ID de la línea de producción o es inválido.");
                window.location.href = "/inyeccion";
                return;
            }else{
                let inputIdLinea = modalEditarLineaPnc.querySelector('#idLineaTiempoMuerto');
                let inputIdReporte = modalEditarLineaPnc.querySelector('#idEncabezadoReporteInyeccion');

                if(inputIdLinea && inputIdReporte){
                    inputIdLinea.value = idLineaProduccion;
                    inputIdReporte.value = idPncInyeccion;
                    window.infoLineaTiempoMuertoInyeccion(idLineaProduccion);
                }else{
                    alert("No se encontró el campo oculto para el ID del encabezado del reporte.");
                    window.location.href = "/inyeccion";
                    return;
                }
            }
        }
    });
}
